<template>
  <PrivacySection title="8. Cookie e Tecnologie Simili">
    <p>
      Il nostro sito web utilizza cookie e tecnologie simili per migliorare l'esperienza 
      di navigazione. Utilizziamo esclusivamente:
    </p>
    <ul>
      <li><strong>Cookie Tecnici:</strong> necessari per il funzionamento del sito web 
          e non richiedono il consenso dell'utente</li>
      <li><strong>Cookie di Sessione:</strong> temporanei, eliminati alla chiusura del browser</li>
    </ul>
    <p>
      Non utilizziamo cookie di profilazione o cookie di terze parti per finalità di 
      marketing o pubblicità.
    </p>
    <p>
      L'utente può gestire le preferenze sui cookie attraverso le impostazioni del 
      proprio browser. Tuttavia, la disabilitazione dei cookie tecnici potrebbe 
      compromettere il funzionamento del sito web.
    </p>
  </PrivacySection>
</template>

<script>
import PrivacySection from '../PrivacySection.vue'

export default {
  name: 'CookiesSection',
  components: {
    PrivacySection
  }
}
</script>

